export const REALTIME_REPORT_ENDPOINT = '/realtime_report?';